export const PAGE_TITLE_FIELD: string = "PageTitle";
export const MUSIC_INDUSTRY_HEADER_FIELD: string = "MusicIndustryHeader";
export const LOGIN_HEADER_FIELD: string = "LoginHeader";
export const EMAIL_LABEL_FIELD: string = "EmailLabel";
export const PASSWORD_LABEL_FIELD: string = "PasswordLabel";
export const LOGIN_LABEL_FIELD: string = "LoginLabel";
export const REGISTER_LINK_FIELD: string = "RegisterLink";
export const LOGIN_FAILED_FIELD: string = "LoginFailed";
export const FORGOT_PASSWORD_LINK_TEXT_FIELD: string = "ForgotPasswordLinkText";